export default {
  fastRegistration: 'Fast registration',
  userEnter: 'client login',
  contacts: 'contact',
  findOutTheCost: 'Get quote',
  brand: 'SOVTES',
  register: 'Register',
  metaTags: {
    metaTitle:
      'Sovtes - online logistics, freight management, ЕТТН, eCMR, web application',
    metaDecription:
      'Sovtes is a web application for the control of cargo transportation. It allows you to effectively manage cargo transportation by automating logistics processes. Registration of an electronic consignment note, ЕТТН, eCMR',
    metaKeywords:
      'Cargo transportation, free routes for carriers, online logistics, sovtes program, sovtes, ETTN, eCMR',
    ttnDescription:
      'Allows you to register an electronic waybill online for free with a digital signature in Ukraine, add ETTN, eCMR',
    ttnKeywords:
      'Registration of eTTN eCMR online for free, ETTN, electronic consignment note with digital signature, Sovtes program, Sovtes, ETTN',
    ttnTitle:
      'Registration of TTN online for free in Ukraine, ЕТТН, eTTN - Sovtes',
    thankyouTitle: 'Thank you - Sovtes',
    thankyou2Title: 'Thanks - Sovtes',
    thankyou3Title: 'Thanks - Sovtes',
    thankyou4Title: 'Thanks - Sovtes',
    thankyou5Title: 'Thanks - Sovtes',
    thankyou6Title: 'Thanks - Sovtes',
  },
  nav: {
    links: {
      1: 'app',
      5: 'audit',
      2: 'carriers',
      3: 'shippers',
      4: 'pricing',
    },
  },
  sectionMain: {
    msg1: 'up to 25% cost savings',
    msg2: 'on road freight',
    registration: 'Registration',
    knowMore: 'Learn more about the product',
    thankyou1: 'Thank you! We will contact you shortly',
    thankyou2: 'Thank you! We will contact you shortly',
    thankyou3: 'Thank you! We will contact you shortly',
    thankyou4: 'Thank you! We will contact you shortly',
    thankyou5: 'Thank you! We will contact you shortly',
    thankyou6: 'Thank you! We will contact you shortly',
    ettn1: 'Thanks for signing ETTN, eCMR',
    ettn2: 'To continue, click on the blue "ETTH Signed" button below',
    ttn1: 'Registration of ETTN is free: electronic TTN in Ukraine',
    ttn2: 'Register and we will connect you to ЕТТН',
  },
  sectionSlogan: {
    msg1: 'Your primary freight management system',
    msg2: 'The SAAS solution for efficient freight management',
  },
  sectionPositions: {
    list: {
      1: 'simplicity',
      2: 'efficiency',
      3: 'availability',
    },
    msg1:
      'Find out how to solve road freight logistics challenges of your business. We will send a free presentation to your email, specially designed by our logistics experts.',
  },
  sectionAudit: {
    title: 'audit of freight rates',
    footer: {
      txt1: 'Sovtes LLC is one of the',
      link:
        '7 authorized providers of the electronic consignment notes of Ukraine.',
      txt2: 'Connect to the central eCMR registry with an authorized provider',
    },
  },
  sectionAdvantages: {
    title: 'benefits of',
    shipper: 'For shippers',
    transporter: 'For carriers',
    lists: {
      transporter: {
        11: {
          label: 'Relevant orders',
          description:
            'Sovtes cooperates only with direct customers, excludes the possibility of duplicate transportation orders.',
        },
        12: {
          label: 'Profitable partnership',
          description:
            'By becoming a Sovtes partner, you get access to all requests from our clients without the need to conclude additional contracts.',
        },
        13: {
          label: 'Fast contracts',
          description:
            'The order in Sovtes contains all the necessary data about the transportation. It is enough to offer the vehicle and sign the application, which is generated automatically. No calls.',
        },
        14: {
          label: 'Fast payments',
          description:
            'By arranging transportation through Sovtes, you are guaranteed to receive payment for the performed transportation within 10 days after unloading.',
        },
        15: {
          label: 'New customers',
          description:
            'We are constantly working on attracting new customers for transport services, you just need to choose with whom and on what conditions to work.',
        },
        16: {
          label: 'Cost reduction',
          description:
            'Empty loads waste your profits. We suggest you reduce downtime and empty trips by accessing more up-to-date transportation requests.',
        },
      },
      shipper: {
        21: {
          label: 'Quick Launch',
          description:
            'Full system launch in an enterprise takes less than 5 days.',
        },
        22: {
          label: 'Economy',
          description:
            'The SOVTES system guarantees a 22-25% cost reduction for road transport.',
        },
        23: {
          label: 'Reporting',
          description:
            'Automatic timely and actionable reports according to your needs.',
        },
        24: {
          label: 'Speed',
          description:
            'It takes only several minutes to find the appropriate vehicle.',
        },
        25: {
          label: 'Electronic document flow',
          description: 'Simplify and expedite your cooperation with carrers.',
        },
        26: {
          label: 'Integration',
          description:
            'Automation of data exchange with your business ERP systems.',
        },
      },
    },
  },
  partners: {
    title: 'partners of',
    subTitle: 'Perks for Clients of Sovtes:',
    list: {
      1: {
        description: 'First two months for the service "Vchasno" for free',
      },
      2: {
        description:
          'Co-founder of Sovtes Oleg Rudkovskiy is the head of the Committee on Transport and Logistics of the SUP NGO (Ukrainian Entrereneurs Community)',
      },
    },
  },
  clientsSection: {
    title: 'clients of',
    list: {
      1: {
        name: 'Alexey Nod',
        rank: 'Head of the transport logistics department of MCHP "JSC"',
        comment:
          'We have been cooperating with the team since 2014. We would like to thank Sovtes for creating an effective product that is constantly evolving! Thanks to your portal, we have gained new business partners, significantly reduced the time for processing applications and provided transport with constant loads. We wish the project further prosperity! Only forward!',
      },
      2: {
        name: 'Anna Khvatova',
        rank: 'Head of the Department of Transport Logistics LLC TD Schedro',
        comment:
          'Among the main advantages is the possibility of organizing full transparency of the tender procedure, as well as saving money and time to solve problems. For our company, the implementation of the system has become one of the most effective methods of ensuring fair competition and transparency in the procurement of transport services. ',
      },
      3: {
        name: 'Lilia KUSHNARYOVA',
        rank:
          'Director of the Administrative and Logistics Department of Global Spirits (TM Khortytsia)',
        comment:
          'We have been cooperating with SOVTES for over a year. This is a multifunctional information program that saves our time and money. With SOVTES, you and your carriers will always have up-to-date information. SOVTES platform - is easy to use and reliable storage of information. We recommend cooperation! ',
      },
    },
  },
  howItWorks: {
    title: 'features of',
    list: {
      1: {
        label: 'Reporting',
        description:
          'The list of stored data allows us to compile the necessary reports in accordance with the requirements of our customers. At the request of customers, we develop personalized reports, the system automatically generates and sends them to the appropriate person. ',
      },
      2: {
        label: 'Document flow',
        description:
          'Electronic document management and automatic document creation can significantly increase the level of security, eliminate the risk of document loss, reduce correspondence costs by up to 99% and speed up the exchange of documents in a few minutes.',
      },
      3: {
        label: 'Ease of interaction',
        description:
          'After the publication of the application, all carriers receive information about the order instantly and simultaneously. The SOVTES functionality provides easy data exchange - both from the customer to carriers, and in the return direction for fast registration of the agreement on transportation. ',
      },
      4: {
        label: 'Accounting',
        description:
          'All actions and critical metrics are stored in secure databases. The ability to integrate through the API provides the transfer of necessary information to the ERP-systems of our customers. Data storage and transmission are fully automated and do not require human resources. ',
      },
    },
  },
  aboutSection: {
    subTitle:
      'a webapp that provides full control of road freight delivery at all stages of transportation, receive up-to-date statistics on your transportation and work with documentation.',
  },
  sectionPrice: {
    title1: 'cost for customer',
    msg1: 'depends on the number of shipments you make per month.',
  },
  forms: {
    shipper: 'I am a customer',
    transporter: 'I am a carrier',
  },
  footer: {
    msg1: 'register ETTN online',
    address: {
      city: '04112, Kyiv,',
      street: '3 Dorogozhytska street',
      house: 'Unit City, B9, of. 414 ',
    },
  },
}
